import { useRef, useEffect } from 'react';
import { isNotNull } from './type-guards.js';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect.js';

function useInterval(callback, delay, options = {}) {
    const { when =true , startImmediate =false  } = options;
    const savedCallback = useRef();
    // Make sure we save the specified callback as soon as possible (browser will use useLayoutEffect)
    useIsomorphicLayoutEffect(()=>{
        savedCallback.current = callback;
    }) // No dependency array as we want to update the callback every render and not every reference change.
    ;
    // Set up the interval.
    useEffect(()=>{
        function tick() {
            var ref;
            (ref = savedCallback.current) === null || ref === void 0 ? void 0 : ref.call(savedCallback);
        }
        if (when) {
            if (startImmediate) {
                tick();
            }
            if (isNotNull(delay)) {
                const id = setInterval(tick, delay);
                return ()=>{
                    clearInterval(id);
                };
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        delay,
        when
    ]) // Note: startImmediate is explicitly omitted from the dep array as that should only have effect once
    ;
}

export { useInterval };
//# sourceMappingURL=use-interval.js.map
